import { Exclude, Expose, Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';
import { InviterInfoDto, TeamInvite } from '..';

@Exclude()
export class TeamInviteDto implements TeamInvite {
  @Expose()
  @IsString()
  email: string;

  @Expose()
  @IsString()
  inviteToken: string;

  @Expose()
  @Type(() => InviterInfoDto)
  @ValidateNested()
  inviterInfo: InviterInfoDto;

  @Expose()
  @IsString()
  status: 'pending' | 'rejected';

  @Expose()
  invitedAt: Date;
}
